import { createContext, useContext } from 'react';
import { SubscriptionStatus } from 'src/types';

import { TariffData } from './use-tariff-data';

export type PaymentState = 'idle' | 'upcoming' | 'overdue' | 'blocked';

export type SubscriptionContextType = TariffData & {
  status: SubscriptionStatus | null;
  isLoading: boolean;
  paymentState: PaymentState;
  studentUsagePct: number;
  studentUsed: number;
  studentLimit: number;
  isStudentAtLimit: boolean;
  showStudentBanner: boolean;
  memberUsagePct: number;
  memberUsed: number;
  memberLimit: number;
  isMemberAtLimit: boolean;
  showMemberBanner: boolean;
  paymentBannerDismissed: boolean;
  dismissPaymentBanner: () => void;
  studentBannerDismissed: boolean;
  dismissStudentBanner: () => void;
  memberBannerDismissed: boolean;
  dismissMemberBanner: () => void;
};

export const SubscriptionContext = createContext<SubscriptionContextType | null>(null);

export const useSubscription = () => {
  const ctx = useContext(SubscriptionContext);

  if (!ctx) throw new Error('useSubscription must be used within SubscriptionProvider');

  return ctx;
};
